import * as React from "react";

import type { ContentSlideProps } from "./interface";

export const ContentSlide = ({ content }: Omit<ContentSlideProps, "type">): JSX.Element => {
  return <>{content}</>;
};
